import { Constructor } from '@angular/cdk/table';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

type WithColumnistContentFormSectionType = {
  _initColumnistContent(isColumnistContentSelected: boolean);
  _initColumnistContentValueChanges(
    getPreviousSelectedValue: () => boolean | null,
  );
  _buildColumnistContent();
};

type WithColumnistContentFormSectionRequerimentsBase = {
  form: FormGroup;
  FORM_PATHS: { COLUMNIST_CONTENT: () => string };
  destroy$: Subject<boolean>;
  formBuilder: FormBuilder;
};

export function WithColumnistContentFormSection<
  TBase extends Constructor<WithColumnistContentFormSectionRequerimentsBase>,
>(
  baseClass: TBase,
): {
  new (...args: any[]): WithColumnistContentFormSectionType;
  prototype: WithColumnistContentFormSectionType;
} & TBase {
  return class extends baseClass {
    constructor(...args: any[]) {
      super(...args);
    }

    _initColumnistContent(isColumnistContentSelected: boolean): void {
      if (isColumnistContentSelected !== null) {
        this.form
          .get(this.FORM_PATHS.COLUMNIST_CONTENT())
          .setValue(isColumnistContentSelected);
      }
    }

    _initColumnistContentValueChanges(
      getPreviousSelectedValue: () => boolean | null,
    ): void {
      this.form
        .get(this.FORM_PATHS.COLUMNIST_CONTENT())
        .valueChanges.pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (newValue) => {
            if (newValue === getPreviousSelectedValue()) {
              this.form
                .get(this.FORM_PATHS.COLUMNIST_CONTENT())
                .markAsPristine();
            } else {
              this.form.get(this.FORM_PATHS.COLUMNIST_CONTENT()).markAsDirty();
            }
          },
        });
    }

    _buildColumnistContent(): boolean {
      return this.form.get(this.FORM_PATHS.COLUMNIST_CONTENT()).value;
    }
  };
}
